import { atom, action } from "nanostores";
import { CartData } from "./cartTypes";
import { getCart, removeCoupon, validateCoupon } from "./api";
import { __t } from "./translate";

const persistentAtom = (name: string, initial: undefined | string | boolean | null = undefined, opts = {}) => {
  let encode = opts.encode || JSON.stringify
  let decode = opts.decode || JSON.parse

  let store = atom(initial)
  store.isLocalStorage = true;

  let set = store.set
  store.set = newValue => {
    if (typeof newValue === 'undefined') {
      delete localStorage[name]
    } else {
      localStorage[name] = encode(newValue)
    }
    set(newValue)
  }

  store.restore = () => {
    store.set(localStorage[name] ? decode(localStorage[name]) : initial)
  }

  return store
}

export const $storeLoaded = atom(false);

export const $isOrderSuccessful = persistentAtom('orderSuccessful', undefined);

export const $cartStore = persistentAtom('cart', null);

export const $shippingInfo = persistentAtom('shippingInfo', {});
export const $billingInfo = persistentAtom('billingInfo', {});
export const $gdprShown = persistentAtom('gdpr', undefined);
export const $gdprMarketing = persistentAtom('gdpr_marketing', true);
export const $gdprPreferences = persistentAtom('gdpr_preferences', true);
export const $gdprStatistics = persistentAtom('gdpr_statistics', true);

export const $isCheckoutEnabled = atom(true);
export const $isSideCartOpen = atom(false);
export const $showPaymentForm = atom(false);
export const $isCarouselDisplayed = atom(false);
export const $checkoutErrorMessage = atom<null | string>(null);
export const $stateRequired = atom(false);
export const $stateBillingRequired = atom(false);
export const $updatedConsent = atom(false);
export const $userId = atom(typeof window !== 'undefined' ? localStorage.getItem('user_id') : 'false');

export const setUserId: (userId: string) => void = (userId) => {
  $userId.set(userId);
  window.localStorage.setItem('user_id', userId);
};

export const updateCartStore: (cart: CartData) => void = (cart: CartData) => {
  $cartStore.set({ ...cart });
};

export const loadCart = action($cartStore, "loadCart", async () => {
  const res = await getCart();

  if (!res) return;

  updateCartStore(res);
});

// prettier-ignore
export const applyCoupon = action($cartStore, 'applyCoupon', async (store, value) => {
  if (value === "") return;

  const res = await validateCoupon(value);

  // handle errors
  if (res?.notice?.length > 0) {
    return res.notice[0].notice;
  }

  updateCartStore(res);
  return __t("Coupon applied successfully!");
})

// prettier-ignore
export const removeCouponFromCart = action($cartStore, 'removeCoupon', async (store, value) => {
  if (value === "") return;

  const res = await removeCoupon(value);

  // handle errors
  if (res?.applied_coupons?.length > 0) {
    return "Unknown error";
  }

  updateCartStore(res);
  return __t("Coupon removed successfully!");
})
